import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeIndex from '@/views/Home/index.vue'
import { useStore } from 'vuex'
type RouteRecordRaw = typeof RouteRecordRaw

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeIndex,
    children: [
      {
        path: '',
        name: 'homeIndex',
        component: () => import('@/views/Index/index.vue')
      },
      {
        path: 'account',
        name: 'accountContent',
        component: () => import('@/views/Account/index.vue'),
        children: [
          {
            path: 'signin',
            name: 'signin',
            component: () => import('@/views/Account/Signin/index.vue')
          },
          {
            path: 'register',
            name: 'register',
            component: () => import('@/views/Account/Register/index.vue')
          }
        ]
      },
      {
        path: 'video',
        name: 'video',
        component: () => import('@/views/Video/index.vue')
      },
      {
        path: 'liveActivity',
        name: 'liveActivity',
        component: () => import('@/views/LiveActivity/index.vue')
      },
      {
        path: 'tkLp',
        name: 'tkLandingPage',
        component: () => import('@/views/LandingPage/tk.vue')
      },
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
router.beforeEach(async (to: any, from: any, next: any) => {
  console.log('to', to)
  const store = useStore()
  if (store.getters.token) {
    if (['signin'].includes(to?.name)) {
      next('/')
      return
    }
    await store.dispatch('user/GET_USER_INFO')
  }
  next()
})
export default router
